export default __webpack_public_path__ + "img/sort-solid.8489f899685b634b072bda3f5103edf9.svg";